import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography, Stack, Button } from '@mui/material';
import { FileGroupLayout } from './FileGroupLayout';

const LoadingState = () => (
  <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
    <CircularProgress size={24} />
    <Typography variant="body2" ml={1}>
      Loading files...
    </Typography>
  </Stack>
);

const ErrorState = ({ error }) => (
  <Typography variant="body2" color="error" mt={2}>
    Error loading files:
    {' '}
    {error?.data?.message || 'Unexpected error.'}
  </Typography>
);

ErrorState.propTypes = {
  error: PropTypes.shape({
    data: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
};

export const FileGroupPanel = ({ queryResult, onLoadMore, groupBy }) => {
  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
  } = queryResult;

  if (isLoading) return <LoadingState />;
  if (isError) return <ErrorState error={error} />;
  if (!data?.items?.length) return null;

  const groups = data.items;
  const { nextCursor } = data;

  return (
    <>
      <FileGroupLayout groups={groups} groupBy={groupBy} />
      {nextCursor && (
        <Stack direction="row" justifyContent="center" mt={2}>
          <Button
            variant="outlined"
            onClick={onLoadMore}
            disabled={isFetching}
          >
            {isFetching ? 'Loading...' : 'Load More'}
          </Button>
        </Stack>
      )}
    </>
  );
};

FileGroupPanel.propTypes = {
  queryResult: PropTypes.shape({
    data: PropTypes.shape({
      items: PropTypes.array,
      nextCursor: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
    isFetching: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.object,
  }).isRequired,
  onLoadMore: PropTypes.func.isRequired,
  groupBy: PropTypes.oneOf(['date', 'advisor_login']).isRequired,
};
